import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent implements OnInit {
  title = 'hendyghsta development';

  ngOnInit() {
    this.loadScript('http://maps.google.com/maps/api/js?sensor=false&amp;language=en');
    this.loadScript('//marqet.disqus.com/count.js');
  }

  public loadScript(url: string) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.type = 'text/javascript';
    body.appendChild(script);
    // add in assets
  }
}
